<script setup lang="ts">
import DashHero from '@/components/dashboard/DashHero.vue';
import DashKpis from '@/components/dashboard/DashKpis.vue';
import DashAlerts from '@/components/dashboard/DashAlerts.vue';
import DashOnboarding from '@/components/dashboard/DashOnboarding.vue';
import DashActivity from '@/components/dashboard/DashActivity.vue';
import DashClients from '@/components/dashboard/DashClients.vue';
</script>

<template>
  <div class="dash">
    <div class="dash__wrap">
      <!-- Hero : titre + boutons (pleine largeur, pas de card) -->
      <DashHero />

      <!-- 3 grandes KPI cards -->
      <DashKpis />

      <!-- 5 petites stat cards -->
      <DashAlerts />

      <!-- Grille principale : gauche 8/12 + droite 4/12 -->
      <div class="dash__main-grid">
        <div class="dash__left">
          <DashOnboarding />
        </div>
        <div class="dash__right">
          <DashActivity />
        </div>
      </div>

      <!-- Table clients pleine largeur -->
      <DashClients />
    </div>
  </div>
</template>

<style scoped>
.dash {
  min-height: 100%;
  background: #fcfcfd;
  box-sizing: border-box;
}

.dash__wrap {
  padding: 2.5rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-sizing: border-box;
}

@media (max-width: 1023px) {
  .dash__wrap {
    padding: 1.5rem;
    gap: 1.25rem;
  }
}
@media (max-width: 639px) {
  .dash__wrap {
    padding: 1rem;
    gap: 1rem;
  }
}

/* Grille principale 8/4 */
.dash__main-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: start;
}
@media (min-width: 1024px) {
  .dash__main-grid {
    grid-template-columns: 8fr 4fr;
  }
}

.dash__left,
.dash__right {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-width: 0;
}
</style>

<style>
[data-theme='dark'] .dash {
  background: #0c1421;
}
</style>
